var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.17,
    height: 28.17,
    viewBox: "0 0 28.17 28.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1._Phone",
    "data-name": "1. Phone",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M19.86,28.17H8.31c-2.93,0-5.3-1.89-5.31-4.217V4.217C3.006,1.89,5.38,0,8.31,0H19.86c2.93,0,5.3,1.89,5.31,4.217V4.4a1.138,1.138,0,0,1-2.217,0V4.217c0-1.356-1.385-2.456-3.093-2.456H8.31c-1.708,0-3.093,1.1-3.093,2.456V23.953c0,1.356,1.385,2.456,3.093,2.456H19.86c1.708,0,3.093-1.1,3.093-2.456V22.008a1.138,1.138,0,0,1,2.217,0v1.945c-.006,2.327-2.38,4.212-5.31,4.217Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M13,28a2,2,0,1,1,2-2A2,2,0,0,1,13,28ZM13,26Z",
    transform: "translate(0.789 -3.83)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M16,6H10a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z",
    transform: "translate(0.723)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_537",
    "data-name": "Rectangle 537",
    width: 4,
    height: 5,
    rx: 1,
    transform: "translate(21.677 6.865)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M26,22H18a3,3,0,0,1-3-3V11a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3v8A3,3,0,0,1,26,22ZM18,10a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V11a1,1,0,0,0-1-1Z",
    transform: "translate(2.17 -1.702)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M21,18H20a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Z",
    transform: "translate(1.51 -2.043)",
    fill: "#616161"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2e5bbf384247bf4a4f56a44a1ed5fb00.svg";
export { ForwardRef as ReactComponent };